var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFileAlt = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 16,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file-alt",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "file-alt-2",
    "data-name": "file-alt",
    d: "M11.541,2.958,8.924.34A1.5,1.5,0,0,0,7.866-.1H1.5A1.5,1.5,0,0,0,0,1.4V14.38a1.5,1.5,0,0,0,1.5,1.5h8.986a1.5,1.5,0,0,0,1.5-1.5V4.019A1.5,1.5,0,0,0,11.541,2.958Zm-.705.708a.491.491,0,0,1,.131.231H7.987V.917a.491.491,0,0,1,.231.131ZM10.484,14.88H1.5a.5.5,0,0,1-.5-.5V1.4A.5.5,0,0,1,1.5.9H6.989V4.146a.747.747,0,0,0,.749.749h3.245V14.38A.5.5,0,0,1,10.484,14.88Zm-1.5-7.613v.25a.376.376,0,0,1-.374.374H3.37A.376.376,0,0,1,3,7.516v-.25a.376.376,0,0,1,.374-.374H8.612A.376.376,0,0,1,8.986,7.267Zm0,2v.25a.376.376,0,0,1-.374.374H3.37A.376.376,0,0,1,3,9.513v-.25a.376.376,0,0,1,.374-.374H8.612A.376.376,0,0,1,8.986,9.263Zm0,2v.25a.376.376,0,0,1-.374.374H3.37A.376.376,0,0,1,3,11.51v-.25a.376.376,0,0,1,.374-.374H8.612A.376.376,0,0,1,8.986,11.26Z",
    transform: "translate(0 0.1)",
    fill: "#047BC1"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFileAlt);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/file-alt.bad5cb59164cae9d20926c965bf2ab93.svg";